<div class="filters" cdkDropList cdkDropListOrientation="horizontal" [cdkDropListConnectedTo]="[deleteArea]" cdkDropListLockAxis="x"
  (cdkDropListDropped)="onDropPosFilter($event)">
  <div class="filter-tabs">
    <div *ngFor="let filter of getShowFilters()" class="filter-tab">
      <button cdkDrag [cdkDragData]="filter" class="btn btn-filter btn-filter-primary dropdown-toggle" [dropdown]="dropdownContent"
        (onDropdownShow)="onShowFilter(filter, dropdownContent)" [tooltip]="filter.value ? filter.value : ''" tooltipPlacement="bottom">
        <i class="icon-drag-indicator"></i> {{ filter.title }} <span *ngIf="filter.value">: {{ filter.value }}</span>
      </button>
      <ng-template #dropdownContent let-dr="dropdown">
        <div [ngSwitch]="filter.title" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
          <div *ngSwitchCase="'Service'" class="list-filter mx-10">
            <h5 class="text-muted">{{ filter.title }}</h5>
            <ul class="list-filter-items">
              <li *ngFor="let s of serviceValues" (click)="onChangeFilterValue(s.title, filter);dr.hide();" [ngClass]="{active: s.title === filter.value}">
                {{ s.title }}
              </li>
            </ul>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button [disabled]="!filter.value" class="btn mr-10" (click)="onChangeFilterValue('', filter);dr.hide();">Clear</button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="filter-controls">
    <button class="btn btn-filter filter-add-btn" [disabled]="!getHiddenFilters().length" [dropdown]="hiddenFilters">
      <i class="icon-add"></i> Add Filter
    </button>
    <ng-template #hiddenFilters let-dr="dropdown">
      <ul class="dropdown-menu rounded-15 bg-neutral-n1">
        <li *ngFor="let filter of getHiddenFilters()" class="dropdown-item filter-item px-15 py-10" (click)="onClickShowFilter(filter, dr)">
          <a>{{ filter.title }}</a>
        </li>
      </ul>
    </ng-template>
    <button cdkDropList cdkDropListLockAxis="x" #deleteArea="cdkDropList" (cdkDropListDropped)="onDropFilter($event)" class="btn btn-filter delete-area"
      (click)="resetFilters()">
      <i class="far fa-trash-alt"></i> Clear
    </button>
  </div>
</div>
